/* GAME CATALOGUE REDUX — THE TYPES AND THE GAMES COME FROM THE DATABASE, NOT FROM THE CONSTANTS ANYMORE */

const DEFAULT = {
    types: [],
    games: [],
    studios: [],
    currencies: [],
}

const catalog = (state = DEFAULT, action) => {

    switch (action.type) {

        case "SET_CATALOG":
            return action.payload

        default:
            return state

    }
}

export default catalog
